import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

// interface IGetUserEventHistoryRequest {
//   accountNumber: string;
// }
export interface IUserEventHistoryData {
  id: string;
  customerAccountNumber: string;
  customerName: string;
  customerPhoneNumber: string;
  amount: number;
  title: string;
  productId: string;
  productInfo: {
    dateTime: string;
    description: string;
  };
  providerResponse: {
    data: {
      userId: string;
      success: boolean;
      expiresIn: string;
      productId: string;
      accessCode: string;
      redemptionLink: string;
    };
    status: boolean;
    message: string;
  };
  url: string;
  postingsInstrumentNumber: string;
  clientReference: string;
  internalShare: number;
  providerShare: number;
  transactionStatus: string;
  postingsResponse: {
    data: {
      referenceNumber: string;
      instrumentNumber: string;
    };
    status: boolean;
    message: string;
    statusCode: string;
  };
  postingsStatus: string;
  createdAt: string;
  updatedAt: string;
}

export interface IGetUserEventHistoryResponse {
  status: boolean;
  message: string;
  data: {
    accountNumber: string;
    transactions: IUserEventHistoryData[];
    total: number;
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetUserEventHistoryResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getUserEventHistoryAsync = createAsyncThunk(
  'getUserEventHistory',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const accessToken = state.auth.value?.data?.token?.accessToken;
      const accountNumber = localStorage.getItem('accountNumber') ?? '';
      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };
      const { data } = await api.get(
        `billers/circuit/account/${accountNumber}`,
        config
      );
      return data;
    } catch (err) {
      const error = err as AxiosError<IGetUserEventHistoryResponse>;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const userEventHistoryFetchSlice = createSlice({
  name: 'userEventHistory/get',
  initialState,
  reducers: {
    resetGetUserEventHistory: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builders) => {
    builders
      .addCase(getUserEventHistoryAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getUserEventHistoryAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetUserEventHistoryResponse;
      })
      .addCase(getUserEventHistoryAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetUserEventHistoryResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetUserEventHistory } = userEventHistoryFetchSlice.actions;

export default userEventHistoryFetchSlice.reducer;
